import React, {useState} from 'react';
import {func} from 'prop-types';

import {connect} from 'react-redux';

import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import usePermissions from '../../hooks/usePermissions';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './ConversionMenuPanel.module.css';

const ConversionMenuPanel = ({
    conversions,
    onAddConversion,
    onEditConversion,
    setConversion
}) => {

    const isFullArchitectAllowed = usePermissions('architectFull');
    const [customConversionToggled, setCustomConversionToggled] = useState(false);
    const [k2aConversionToggled, setK2aConversionToggled] = useState(false);

    const key2actConversions = conversions.filter(conversion => conversion.conversionType === 'Key2Act');
    const customConversions = conversions.filter(conversion => conversion.conversionType === 'Custom');

    function handleOpen(event) {
        const itemId = event.currentTarget.id;

        switch (itemId) {
            case 'custom-conversion':
                setCustomConversionToggled(!customConversionToggled);
                break;
            case 'key2act-conversion':
                setK2aConversionToggled(!k2aConversionToggled);
                break;
            default:
                return;
        }
    }

    function handleAddConversionClick() {
        onAddConversion();
    }

    function handleEditConversionClick(conversion) {
        setConversion(conversion);

        onEditConversion();
    }

    return (
        <Paper className={classes.ConversionMenuPanel}>
            <div className={classes.actionBarContainer}>
                <Button
                    disabled={!isFullArchitectAllowed}
                    onClick={handleAddConversionClick}
                    className={classes.addNewConversionButton}
                >
                    <img alt="" className={classes.icon} src="/assets/images/actionBarItem-add.svg" />
                    New Conversion
                </Button>
            </div>
            <div className={classes.menuPot}>
                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                >
                    <ListItem
                        button
                        id="custom-conversion"
                        name="custom"
                        onClick={handleOpen}
                        classes={{
                            root: classes.parentListItem
                        }}
                    >
                        <ListItemIcon>
                            {customConversionToggled ? <ExpandMore /> : <ChevronRight />}
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.parentListItemText
                            }}
                            primary="Custom Conversions"
                        />
                    </ListItem>
                    <Collapse
                        in={customConversionToggled}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List
                            component="div"
                            disablePadding
                        >
                            {customConversions.map(conversion =>
                                <ListItem
                                    button
                                    key={conversion.id}
                                    onClick={() => handleEditConversionClick(conversion)}
                                    classes={{
                                        root: classes.childListItem
                                    }}
                                >
                                    <ListItemText
                                        classes={{
                                            primary: classes.listItemText
                                        }}
                                        primary={conversion.name}
                                    />
                                </ListItem>
                            )}
                        </List>
                    </Collapse>
                    <ListItem
                        button
                        id="key2act-conversion"
                        name="default"
                        onClick={handleOpen}
                        classes={{
                            root: classes.parentListItem
                        }}
                    >
                        <ListItemIcon>
                            {k2aConversionToggled ? <ExpandMore /> : <ChevronRight />}
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.parentListItemText
                            }}
                            primary="K2A Conversions"
                        />
                    </ListItem>
                    <Collapse
                        in={k2aConversionToggled}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List
                            component="div"
                            disablePadding
                        >
                            {key2actConversions.map(conversion =>
                                <ListItem
                                    button
                                    key={conversion.id}
                                    onClick={() => handleEditConversionClick(conversion)}
                                    classes={{
                                        root: classes.childListItem
                                    }}
                                >
                                    <ListItemText
                                        classes={{
                                            primary: classes.listItemText
                                        }}
                                        primary={conversion.name}
                                    />
                                </ListItem>
                            )}
                        </List>
                    </Collapse>
                </List>
            </div>
        </Paper>
    );

};

ConversionMenuPanel.defaultProps = {
    onAddConversion:  () => {},
    onEditConversion: () => {}
};

ConversionMenuPanel.propTypes = {
    onAddConversion:  func,
    onEditConversion: func
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        conversions: state.architect.conversions
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};


export default connect(mapStateToProps, mapDispatchToProps)(ConversionMenuPanel);
